module.exports = __webpack_public_path__ + "img/yy.fbc268cd.png";